import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
import { onMounted } from 'vue';
import Lottie from 'lottie-web';
export default /*#__PURE__*/_defineComponent({
  __name: 'lottieView',
  props: {
    id: {
      type: String,
      default: ''
    },
    jsonData: {
      type: Object,
      default: () => {}
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      defalut: false
    },
    assetsPath: {
      type: String,
      defalut: ''
    }
  },
  emits: ['onComplete'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    let _lottieObj = undefined;
    onMounted(() => {
      let ele = document.getElementById(`lottie-${props.id}`);
      if (ele == undefined) return;
      _lottieObj = Lottie.loadAnimation({
        container: ele,
        renderer: 'svg',
        loop: props.loop,
        autoplay: props.autoplay,
        animationData: props.jsonData,
        assetsPath: props.assetsPath
      });
      _lottieObj.onComplete = evt => {
        emits('onComplete', evt);
      };
    });
    const play = () => {
      _lottieObj && _lottieObj.play();
    };
    const stop = () => {
      _lottieObj && _lottieObj.stop();
    };
    const pause = () => {
      _lottieObj && _lottieObj.pause();
    };
    expose({
      play,
      stop,
      pause
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: `lottie-${__props.id}`
      }, null, 8, _hoisted_1);
    };
  }
});